module.exports = __webpack_public_path__ + "static/media/clamps1.f7e1910e.JPG";